export type TasksSettings = {
  markAsCompleted: boolean;
  markAsPriority: boolean;
};

export type ChangeTaskSettingsAction = {
  type: "MARK_AS_COMPLETED_SETTING" | "MARK_AS_PRIORITY_SETTING";
  payload: boolean;
};

type ResetSettingsAction = {
  type: "RESET_SETTINGS";
};

const tasksSettingsReducer = (
  state: TasksSettings,
  action: ChangeTaskSettingsAction | ResetSettingsAction
) => {
  switch (action.type) {
    case "MARK_AS_COMPLETED_SETTING": {
      return {
        ...state,
        markAsCompleted: action.payload,
      };
    }
    case "MARK_AS_PRIORITY_SETTING": {
      return {
        ...state,
        markAsPriority: action.payload,
      };
    }
    case "RESET_SETTINGS": {
      return {
        markAsCompleted: false,
        markAsPriority: false,
      };
    }
    default:
      return state;
  }
};

export default tasksSettingsReducer;
